import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Card, Col, Row, List, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useStores } from '@app/hooks/stores';
import { Can } from '@app/modules/Auth/components';
import ProfileItem from './ProfileItem';
import './CronTemplates.less';
import { CronProfile } from '@app/modules/Profiles/Schedule/store';

const CronProfiles: React.FC = () => {
  const { cronProfilesStore } = useStores();

  const { listCronProfiles, getCronProfiles, addBlankProfile, loading } = cronProfilesStore;

  useEffect(() => {
    getCronProfiles();
  }, []);

  const addBlankItem = () => {
    addBlankProfile();
  };

  return (
    <Row gutter={24}>
      <Col lg={24} md={24} sm={24}>
        <Card
          title="Schedule profiles"
          extra={
            <Can
              action="post:profiles/cron"
              yes={() => (
                <Button type="link" icon={<PlusOutlined />} onClick={addBlankItem}>
                  Add
                </Button>
              )}
              no={() => null}
            />
          }
        >
          <List
            className="cron-profiles-list"
            loading={loading}
            itemLayout="horizontal"
            size="large"
            pagination={false}
            dataSource={listCronProfiles}
            renderItem={(item: CronProfile) => <ProfileItem item={item} />}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default observer(CronProfiles);
